module.exports = __webpack_public_path__ + "img/w3_chevron_right_dark.5f60accc.5f60accc.png";